import { getAppUrl } from "./services/AppBasePath";

// Keep this module first in index.js: imported assets and lazy chunks use this path.
// eslint-disable-next-line no-undef, camelcase -- webpack replaces this special runtime variable.
__webpack_public_path__ = getAppUrl("/");
